exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Headline{position:relative;margin:auto;padding:5px 0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/Headline/Headline.less
 ** module id = 176
 ** module chunks = 0
 **/